import React, { useLayoutEffect, useEffect, useState } from "react";
import { debounce } from 'lodash';
import { Layout, Row } from "antd";
import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { ThemeProvider } from "styled-components";
import PropTypes from 'prop-types';
import Topbar from "../Topbar/Topbar";
import HamburgerMenu from './hamburgerMenu';
import { siteConfig } from "../../settings";
import themes from "../../settings/themes";
import { themeConfig } from "../../settings";
import AppHolder from "./commonStyle";
import "./global.css";
import appActions from '../../redux/app/actions';
import AppRouter from "./appRouter";
import moment from 'moment';

const { Footer, Content, Sider, Header } = Layout;
const { updateAppView, updateAppHeight } = appActions;

function useWindowSize(props) {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const updateSize = debounce(() => {
    if (!props.isFullScreen) {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    }
  }, 200);

  useLayoutEffect(() => {

    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return size;
}

export function App(props) {

  const { width, height } = useWindowSize(props);
  /**
   * when the app mounts, dispatch the action
   * for updating the state with user options
   * from local storage.
   */

  useEffect(() => {
    props.updateAppView(width);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  useEffect(() => {
    props.updateAppHeight(height);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height]);

  const { url } = props.match;
  return (
    <ThemeProvider theme={themes[themeConfig.theme]}>
      <AppHolder>
        <Layout id="isoContentMainLayout" style={{ overflowX: "hidden", width: '100vw', minHeight: "100vh" }}>

          <Header style={{ padding: 0 }}>
            <Topbar />
          </Header>

          <Layout>
            <Sider style={{backgroundColor: "white"}} collapsed={props.isHambugerMenuCollapsed}>
              <HamburgerMenu />
            </Sider>
            <Content style={{ padding: "12px", background: "#f1f3f6", display: 'flex', flexDirection: 'column' }}>
              <AppRouter url={url} />
            </Content>
          </Layout>

          <Footer
            style={{
              background: "#ffffff",
              textAlign: "center",
              borderTop: "1px solid #ededed",
              padding: 10
            }}
          >
            <Row align={'middle'} style={{ display: 'flex', justifyContent: 'center' }}>
                {'OncoLysis © Admin ' + moment().year() + ' HIPA'}
            </Row>
          </Footer>

        </Layout>
      </AppHolder>
    </ThemeProvider>
  );
}

App.propTypes = {
  updateAppView: PropTypes.func.isRequired,
  updateAppHeight: PropTypes.func.isRequired,
  match: PropTypes.any.isRequired,
};

const mapActionsToProps = {
  updateAppView,
  updateAppHeight,
};

const mapStateToProps = state => {
  return {
    isHambugerMenuCollapsed: state.App.get('isHambugerMenuCollapsed')
  };
};

const injectedApp = injectIntl(App);
const connectedApp = connect(mapStateToProps, mapActionsToProps)(injectedApp);
export default connectedApp;
